import React from "react";
import PageState from "./PageState";

export default class AppErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[Application] Unable to render this page", error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    const failedChunk = /ChunkLoadError|Loading chunk|dynamically imported module/i.test(String(this.state.error));
    return (
      <PageState title={failedChunk ? "A new version is available" : "This page could not be displayed"}
        onRetry={() => failedChunk ? window.location.reload() : this.setState({ error: null })}
        action={<a className="app-button-secondary" href="/dashboard">Go to dashboard</a>}>
        {failedChunk ? "Reload to use the latest version. Any unsaved work on this page may need to be entered again." :
          "Your saved records are still available. Try again, or return to the dashboard."}
      </PageState>
    );
  }
}
